import { injectIntl } from 'react-intl'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as actions from '../indicators.actions'

import * as mapSelectors from '../../Map/map.selectors'

/**
 *  Primary Indicator
 */
class TableIndicator extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
  }

  renderValue(indicator) {
    const { intl } = this.props

    return (
      <div
        key={indicator.id}
        className="markers--table__row--item"
        title={intl.formatMessage({ id: 'indicators.' + indicator.id })}
      >
        <span>{indicator.value}</span>
      </div>
    )
  }

  changeDisplayType(type) {
    const { setDisplayType } = this.props
    setDisplayType(type)
  }

  renderItem(indicator) {
    const { buildingTypes, intl, isVisitor } = this.props

    const canBeClicked = Object.keys(buildingTypes).indexOf(indicator.id) >= 0 && !isVisitor

    return (
      <div
        onClick={canBeClicked ? () => this.changeDisplayType(indicator.id) : null}
        key={indicator.id}
        className="markers--table__row--item"
        title={intl.formatMessage({ id: 'indicators.' + indicator.id })}
      >
        <span className={indicator.icon + ' cursor--pointer'}></span>
      </div>
    )
  }

  /**
   *  Render component.
   */
  render() {
    const { indicators, color } = this.props
    const filteredIndicators = indicators.filter((indicator) => indicator.table == color)

    return (
      <div className={`markers--table ${color}`}>
        <div className="markers--table__row">
          {filteredIndicators.map((i) => this.renderItem(i))}
        </div>
        <div className="markers--table__row">
          {filteredIndicators.map((i) => this.renderValue(i))}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  buildingTypes: mapSelectors.getBuildingTypes(state),
})

const mapDispatchToProps = (dispatch) => ({
  setDisplayType: bindActionCreators(actions.setDisplayType, dispatch),
})

TableIndicator.propTypes = {
  indicators: PropTypes.array,
  buildingTypes: PropTypes.object,
  isVisitor: PropTypes.bool,
  setDisplayType: PropTypes.func,
  color: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TableIndicator))
